module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBlack.9642dfd.ttf";